<template>
  <SplashScreen v-if="showSplash" />
  <router-view v-else />
</template>

<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import { Capacitor } from '@capacitor/core'
import SplashScreen from './components/SplashScreen.vue'
import {
  useAuthStore,
  useGlobalConfigStore,
  useUserConfigStore,
} from './common/store'
import { useClientContextStore } from './client/stores'

const showSplash = ref(true)

// Initialize stores before app renders
const initializeStores = async () => {
  const authStore = useAuthStore()
  const globalConfigStore = useGlobalConfigStore()
  const userConfigStore = useUserConfigStore()

  try {
    if (authStore.isClient) {
      await useClientContextStore().fetchFamilyDashboard()
    }

    // Initialize all config stores in parallel
    await Promise.all([
      globalConfigStore.initialize(),
      userConfigStore.initialize(),
    ])
  } catch (e) {
    // Non-fatal: log in dev, allow app to continue rendering (user may refresh or re-auth)
    if (process.env.ENV === 'DEV') {
      console.error('[App:init] Store initialization failed', e)
    }
  } finally {
    // Always hide splash so UI can render even if some stores failed
    showSplash.value = false
  }
}

onMounted(async () => {
  // Capgo notify handled in boot file; proceed with store init guarded by try/catch
  await initializeStores()
})

if (!Capacitor.isNativePlatform() && 'serviceWorker' in navigator) {
  void navigator.serviceWorker
    .getRegistrations()
    .then(function (registrations) {
      if (registrations.length) {
        for (const registration of registrations) {
          void registration.unregister()
        }
      }
    })
}
</script>
